import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import { useNavigate } from "react-router";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import { api_path } from "../../shared.js";
import swal from "sweetalert";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import BseData from "./BseGridModal";
import ReactHtmlParser from "react-html-parser";
import AddRejectModal from "./AddRejectModal";
import AddCancelModal from "./AddCancelModal";
import AddReceiveModal from "./AddReceiveModal";
export function SalesOrderDetailContent(props) {
  const navigate = useNavigate();
  const [getCrmId, setCrmId] = useState(props.CRM_ID);
  const [getUserRole, setUserRole] = useState(props.USER_ROLE);
  const [getUserEmail, setUserEmail] = useState(props.USER_EMAIL);
  const [getEmpCode, setEmpCode] = useState(props.EMP_CODE);
  const [CarrierData, setCarrierData] = useState([
    {
      CARRIER_ITEM_ID: "",
      CARRIER_CODE: "",
      SERVICES_CONTRACT: "",
      BULLET_CODE: "",
      SC_CONDITION: "",
      SC_VALIDITY: "",
      SCAC: "",
      CARRIER_REMARK: "",
    },
  ]);
  const [showLCL, setShowLCL] = useState(false);
  const [showFCL, setShowFCL] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setSubmitting] = useState(false);
  const [isConfirmButtonDisabled, setConfirmButtonDisabled] = useState(true);
  const [isReceiveButtonDisabled, setReceiveButtonDisabled] = useState(true);
  const [isEditButtonDisabled, setEditButtonDisabled] = useState(true);
  const [isRejectButtonDisabled, setRejectButtonDisabled] = useState(true);
  const [showCancelBtn, setShowCancelBtn] = useState(false);
  const [searchParams] = useSearchParams();
  const [subjectName, setSubjectName] = useState("");
  const order_id = searchParams.get("order_id");
  const copy_id = searchParams.get("copy_id");
  const check_head = searchParams.get("head");
  const ref = searchParams.get("ref");
  const type = searchParams.get("type");
  const docno = searchParams.get("docno");
  const [GET_ORDER_DATE, SET_ORDER_DATE] = useState("");
  const SALES_CRM_UID = searchParams.get("SALES_CRM_UID");
  const [GET_SALES_CRM_UID, SET_SALES_CRM_UID] = useState("");
  const [GET_CREATEBY, SET_CREATEBY] = useState("");
  const [GET_ORDER_NO, SET_ORDER_NO] = useState("");
  const [GET_ORDER_STATUS_ID, SET_ORDER_STATUS_ID] = useState("");
  const [GET_ORDER_STATUS_NAME, SET_ORDER_STATUS_NAME] = useState("");
  const [GET_ORDER_STATUS_STYLE, SET_ORDER_STATUS_STYLE] = useState("");
  const [GET_CUSTOMER_REF, SET_CUSTOMER_REF] = useState("");
  const [GET_QUOTATION_NO, SET_QUOTATION_NO] = useState("");
  const [GET_BOUND_TYPE, SET_BOUND_TYPE] = useState("");
  const [GET_JOB_OWNER, SET_JOB_OWNER] = useState("");
  const [GET_BOOKING_BY, SET_BOOKING_BY] = useState("");
  const [GET_SHIPPER, SET_SHIPPER] = useState("");
  const [GET_AGENT, SET_AGENT] = useState("");
  const [GET_CONSIGNEE, SET_CONSIGNEE] = useState("");
  const [GET_SHIPPERLOAD, SET_SHIPPERLOAD] = useState("");
  const [GET_COLOAD, SET_COLOAD] = useState("");
  const [GET_PARTY_3RD_NAME, SET_PARTY_3RD_NAME] = useState("");
  const [GET_CREDIT_TERM, SET_CREDIT_TERM] = useState("");
  const [GET_CY_TERM, SET_CY_TERM] = useState("");
  const [GET_FINAL, SET_FINAL] = useState("");
  const [GET_CARGO_TYPE, SET_CARGO_TYPE] = useState("");
  const [GET_DG_CLASS, SET_DG_CLASS] = useState("");
  const [GET_DG_TEXT, SET_DG_TEXT] = useState("");
  const [GET_DOOR_BY, SET_DOOR_BY] = useState("");
  const [GET_INCOTERM, SET_INCOTERM] = useState("");
  const [GET_HSCODE, SET_HSCODE] = useState("");
  const [GET_COMMODITY, SET_COMMODITY] = useState("");
  const [GET_LOAD_TYPE, SET_LOAD_TYPE] = useState("");
  const [GET_MBL_TERM, SET_MBL_TERM] = useState("");
  const [GET_HBL_TERM, SET_HBL_TERM] = useState("");
  const [GET_MBL_TYPE, SET_MBL_TYPE] = useState("");
  const [GET_HBL_TYPE, SET_HBL_TYPE] = useState("");
  const [GET_CS, SET_CS] = useState("");
  const [GET_SHIPPING, SET_SHIPPING] = useState("");
  const [GET_TRUCKING, SET_TRUCKING] = useState("");
  const [GET_TRUCKING_REMARK, SET_TRUCKING_REMARK] = useState("");
  const [GET_INSURANCE, SET_INSURANCE] = useState("");
  const [GET_AGENT_SALES_EMAIL, SET_AGENT_SALES_EMAIL] = useState("");
  const [GET_ISF_BY, SET_ISF_BY] = useState("");
  const [GET_AMS_SCAC, SET_AMS_SCAC] = useState("");
  const [GET_ACI_SCAC, SET_ACI_SCAC] = useState("");
  const [GET_FILING_BY, SET_FILING_BY] = useState("");
  const [GET_SHIPPING_DEL, SET_SHIPPING_DEL] = useState("");
  const [GET_TRUCKING_DEL, SET_TRUCKING_DEL] = useState("");
  const [GET_PREALERT_EMAIL, SET_PREALERT_EMAIL] = useState("");
  const [GET_BOOKING_PIC, SET_BOOKING_PIC] = useState("");
  const [GET_DOC_PIC, SET_DOC_PIC] = useState("");
  const [GET_REMARK_TO_CS, SET_REMARK_TO_CS] = useState("");
  const [GET_REMARK_TO_DOC, SET_REMARK_TO_DOC] = useState("");
  const [GET_REMARK_TO_ACC, SET_REMARK_TO_ACC] = useState("");
  const [GET_POR, SET_POR] = useState("");
  const [GET_POL, SET_POL] = useState("");
  const [GET_POD, SET_POD] = useState("");
  const [GET_DEL, SET_DEL] = useState("");
  const [GET_POR_NAME, SET_POR_NAME] = useState("");
  const [GET_POL_NAME, SET_POL_NAME] = useState("");
  const [GET_POD_NAME, SET_POD_NAME] = useState("");
  const [GET_DEL_NAME, SET_DEL_NAME] = useState("");
  const [GET_FINAL_NAME, SET_FINAL_NAME] = useState("");
  const [GET_FINAL_ADDRESS, SET_FINAL_ADDRESS] = useState("");
  const [getSale, setSale] = useState();
  const [getCS, setCS] = useState();
  const [getAttachment, setAttachment] = useState("");
  const [GET_STATUS_REASON, SET_STATUS_REASON] = useState("");
  const [GET_STATUS_REMARK, SET_STATUS_REMARK] = useState("");
  const [GET_CNT20, SET_CNT20] = useState("");
  const [GET_TYPE20, SET_TYPE20] = useState("");
  const [GET_GW20, SET_GW20] = useState("");
  const [GET_CNT40, SET_CNT40] = useState("");
  const [GET_TYPE40, SET_TYPE40] = useState("");
  const [GET_GW40, SET_GW40] = useState("");
  const [GET_CNT40HQ, SET_CNT40HQ] = useState("");
  const [GET_TYPE40HQ, SET_TYPE40HQ] = useState("");
  const [GET_GW40HQ, SET_GW40HQ] = useState("");
  const [GET_CNT45, SET_CNT45] = useState("");
  const [GET_TYPE45, SET_TYPE45] = useState("");
  const [GET_GW45, SET_GW45] = useState("");
  const [GET_CUSTOMER_CODE, SET_CUSTOMER_CODE] = useState("");
  const [GET_PAPERLESS_CODE, SET_PAPERLESS_CODE] = useState("");
  const [GET_INVOICE_CHARGE_TO, SET_INVOICE_CHARGE_TO] = useState("");
  const [GET_GW, SET_GW] = useState("");
  const [GET_NO_OF_PACK, SET_NO_OF_PACK] = useState("");
  const [GET_PACKAGE_UNIT, SET_PACKAGE_UNIT] = useState("");
  const [GET_CBM, SET_CBM] = useState("");
  const [GET_DIMENSION_NOTE, SET_DIMENSION_NOTE] = useState("");
  const [GET_WAITING_FLAG, SET_WAITING_FLAG] = useState("");
  const [GET_PRIORITY, SET_PRIORITY] = useState("");
  const [GET_CARGO_READY, SET_CARGO_READY] = useState(null);
  const [GET_CY_DATE, SET_CY_DATE] = useState(null);
  const [GET_RETURN_DATE, SET_RETURN_DATE] = useState(null);
  const [GET_ETD_DATE, SET_ETD_DATE] = useState(null);
  const [GET_ETA_DATE, SET_ETA_DATE] = useState(null);
  const [showSale, setShowSale] = useState(false);
  const [showCs, setShowCs] = useState(false);

  const fetchCarrierData = async () => {
    const response = await fetch(
      api_path + "/TS_SALES_ORDER_ITEM.php?order_id=" + order_id + "",
    );
    const data = await response.json();
    setCarrierData(data);
  };

  useEffect(() => {
    if (order_id || copy_id) {
      let id = 0;
      if (order_id) {
        id = order_id;
        setSubjectName("Sales Order details");
      } else if (copy_id) {
        id = copy_id;
        setSubjectName("Copy Sales Order");
      }
      fetchCarrierData();
      //view or edit
      fetch(api_path + "/TS_SALES_ORDER.php?order_id=" + id)
        .then((res) => res.json())
        .then((res) => {
          const array = res;
          for (const i of array) {
            fetchReasonData(id, i.ORDER_STATUS);
            SET_ORDER_NO(i.ORDER_NO);
            SET_ORDER_STATUS_ID(i.ORDER_STATUS);
            SET_ORDER_STATUS_NAME(i.STATUS_NAME);
            if (i.ORDER_STATUS == "5") {
              SET_ORDER_STATUS_STYLE("waiting2");
            } else if (i.ORDER_STATUS == "4") {
              SET_ORDER_STATUS_STYLE("waiting");
            } else {
              SET_ORDER_STATUS_STYLE(i.STATUS_NAME);
            }

            SET_CREATEBY(i.CR_NAME);
            if (i.ORDER_STATUS == "0") {
              //draft
              setConfirmButtonDisabled(true);
              setReceiveButtonDisabled(false);
              setRejectButtonDisabled(false);
              setShowCancelBtn(false);
              setEditButtonDisabled(true);
            } else if (i.ORDER_STATUS == "1") {
              //New
              setEditButtonDisabled(true);
              setConfirmButtonDisabled(false);
              setReceiveButtonDisabled(true);
              setRejectButtonDisabled(true);
              setShowCancelBtn(true);
            } else if (i.ORDER_STATUS == "2") {
              //Receive
              setEditButtonDisabled(true);
              setConfirmButtonDisabled(false);
              setReceiveButtonDisabled(false);
              setRejectButtonDisabled(false);
              setShowCancelBtn(true);
            } else if (i.ORDER_STATUS == "3") {
              //Reject
              setEditButtonDisabled(true);
              setConfirmButtonDisabled(false);
              setReceiveButtonDisabled(false);
              setRejectButtonDisabled(false);
              setShowCancelBtn(true);
            } else if (i.ORDER_STATUS == "4") {
              //waiting Released
              setEditButtonDisabled(true);
              setConfirmButtonDisabled(false);
              setReceiveButtonDisabled(false);
            } else if (i.ORDER_STATUS == "5") {
              //Wait Sales to confirm
              setEditButtonDisabled(true);
              setConfirmButtonDisabled(false);
              setReceiveButtonDisabled(false);
              setRejectButtonDisabled(false);
              setShowCancelBtn(true);
            } else if (
              i.ORDER_STATUS == "6" ||
              i.ORDER_STATUS == "7" ||
              i.ORDER_STATUS == "8" ||
              i.ORDER_STATUS == "10" ||
              i.ORDER_STATUS == "11"
            ) {
              //Sales confirm
              setEditButtonDisabled(false);
              setConfirmButtonDisabled(false);
              setReceiveButtonDisabled(false);
              setShowCancelBtn(false);
            } else if (i.ORDER_STATUS == "9") {
              //Cancel
              setEditButtonDisabled(true);
              setConfirmButtonDisabled(false);
              setReceiveButtonDisabled(false);
              setRejectButtonDisabled(false);
              setShowCancelBtn(false);
            }
            SET_SALES_CRM_UID(i.SALES_ID);
            SET_QUOTATION_NO(i.QUOTATION_NO);
            SET_CUSTOMER_REF(i.CUSTOMER_REF);
            setSale(i.SALE_EMAIL);
            setCS(i.CS_EMAIL);
            setAttachment(i.ATTACHMENT);
            SET_CARGO_READY(i.CARGO_READY);
            SET_CY_DATE(i.CY_DATE);
            SET_RETURN_DATE(i.RETURN_DATE);
            SET_ETD_DATE(i.ETD_DATE);
            SET_ETA_DATE(i.ETA_DATE);
            if (i.BOUND_TYPE == "EXPORT") {
              SET_BOUND_TYPE("EXPORT");
            } else if (i.BOUND_TYPE == "IMPORT") {
              SET_BOUND_TYPE("IMPORT");
            }
            if (i.JOBOWNER == "FREEHAND") {
              SET_JOB_OWNER("FREEHAND");
            } else if (i.JOBOWNER == "NOMINATE") {
              SET_JOB_OWNER("NOMINATE");
            }
            SET_BOOKING_BY(i.BOOKING_BY);
            if (i.DOOR_BY == "AGENT") {
              SET_DOOR_BY("AGENT");
            } else if (i.DOOR_BY == "CARRIER") {
              SET_DOOR_BY("CARRIER");
            }
            if (i.LOADTYPE == "LCL") {
              setShowLCL(true);
              setShowFCL(false);
            } else {
              setShowLCL(false);
              setShowFCL(true);
            }
            SET_CUSTOMER_CODE(i.CUSTOMER_CODE);
            SET_PAPERLESS_CODE(i.PAPERLESS_CODE);
            SET_INVOICE_CHARGE_TO(i.INVOICE_CHARGE_TO);
            SET_CARGO_READY(i.CARGO_READY);
            SET_PARTY_3RD_NAME(i.PARTY_3RD_NAME);
            SET_CREDIT_TERM(i.CREDIT_TERM);
            SET_HSCODE(i.HSCODE);
            SET_DG_CLASS(i.DG_CLASS);
            SET_CARGO_TYPE(i.CARGO_TYPE_TEXT);
            if (i.CARGO_TYPE == "DG") {
              SET_DG_TEXT("DG CLASS/UN NO:");
            } else {
              SET_DG_TEXT("TEMPERATURE");
            }
            SET_COMMODITY(i.COMMODITY);
            SET_SHIPPING(i.SHIPPING);
            SET_TRUCKING(i.TRUCKING);
            SET_TRUCKING_REMARK(i.TRUCKING_REMARK);
            SET_INSURANCE(i.INSURANCE);
            SET_SHIPPING_DEL(i.SHIPPING_DEL);
            SET_TRUCKING_DEL(i.TRUCKING_DEL);
            SET_AGENT_SALES_EMAIL(i.AGENT_SALES_EMAIL);
            SET_ISF_BY(i.ISF_BY);
            SET_AMS_SCAC(i.AMS_SCAC);
            SET_FILING_BY(i.FILING_BY);
            SET_PREALERT_EMAIL(i.PREALERT_EMAIL);
            SET_BOOKING_PIC(i.BOOKING_PIC);
            SET_DOC_PIC(i.DOC_PIC);
            SET_REMARK_TO_CS(ReactHtmlParser(i.REMARK_TO_CS));
            SET_REMARK_TO_DOC(ReactHtmlParser(i.REMARK_TO_DOC));
            SET_REMARK_TO_ACC(ReactHtmlParser(i.REMARK_TO_ACC));
            //  SET_REMARK_TO_CS(i.REMARK_TO_CS);
            //  SET_REMARK_TO_DOC(i.REMARK_TO_DOC);
            //  SET_REMARK_TO_ACC(i.REMARK_TO_ACC);
            SET_SHIPPER(i.SHIPPER_NAME);
            SET_CONSIGNEE(i.CNEE_NAME);
            SET_AGENT(i.AGENT_NAME);
            SET_SHIPPERLOAD(i.SHIPPERLOAD_NAME);
            SET_COLOAD(i.COLOAD_NAME);
            SET_LOAD_TYPE(i.LOADTYPE);
            SET_INCOTERM(i.INCOTERM);
            SET_CY_TERM(i.CYTERM);
            SET_MBL_TERM(i.MBL_TERM);
            SET_MBL_TYPE(i.MBL_TYPE);
            SET_HBL_TERM(i.HBL_TERM);
            SET_HBL_TYPE(i.HBL_TYPE);

            SET_POR(i.POR);
            SET_POL(i.POL);
            SET_POD(i.POD);

            SET_POR_NAME(i.POR_NAME);
            SET_POL_NAME(i.POL_NAME);
            SET_POD_NAME(i.POD_NAME);

            if (i.DEL === null) {
              SET_DEL("-");
            } else {
              SET_DEL(i.DEL);
              SET_DEL_NAME(i.DEL_NAME);
            }
            if (i.FINAL === null) {
              SET_FINAL("-");
            } else {
              SET_FINAL(i.FINAL);
              SET_FINAL_NAME(i.FINAL_NAME);
            }
            SET_FINAL_ADDRESS(i.FINAL_ADDRESS);
            SET_CS(i.CSID);
            SET_ORDER_DATE(i.ORDER_DATE);

            SET_CNT20(i.CNT20);
            SET_TYPE20(i.TYPE20);
            SET_GW20(Number(i.GW20));
            SET_CNT40(i.CNT40);
            SET_TYPE40(i.TYPE40);
            SET_GW40(Number(i.GW40));
            SET_CNT45(i.CNT45);
            SET_TYPE45(i.TYPE45);
            SET_GW45(Number(i.GW45));

            SET_CNT40HQ(i.CNT40HQ);
            SET_TYPE40HQ(i.TYPE40HQ);
            SET_GW40HQ(Number(i.GW40HQ));
            SET_GW(i.GW);
            SET_NO_OF_PACK(i.NO_OF_PACK);
            SET_PACKAGE_UNIT(i.PACKAGE_UNIT);
            SET_CBM(i.CBM);
            SET_DIMENSION_NOTE(ReactHtmlParser(i.DIMENSION_NOTE));
            SET_PRIORITY(i.BOOK_PRIORITY);
            if (i.WAITING_FLAG == "Y") {
              SET_WAITING_FLAG("YES");
            } else {
              SET_WAITING_FLAG("NO");
            }
            if (getUserRole == 1 || getUserRole == 3) {
              //sales
              if (check_head == 1) {
                setShowSale(false);
              } else {
                setShowSale(true);
              }
              setShowCs(false);
            } else if (getUserRole == 2) {
              //sales co
              setShowSale(true);
              setShowCs(false);
            } else if (getUserRole == 11 || getUserRole == 6) {
              fetchCS_BySales(i.SALES_ID, getCrmId);
              setShowSale(false);
            } else {
              setShowSale(false);
              setShowCs(false);
            }
          }
        });
    }
  }, [order_id]);
  const fetchReasonData = async (orderid, orderstatus) => {
    fetch(
      api_path +
        "/TS_SALES_ORDER_LOG.php?order_id=" +
        orderid +
        "&status_id=" +
        orderstatus,
    )
      .then((res) => res.json())
      .then((res) => {
        const array = res;
        for (const i of array) {
          SET_STATUS_REMARK(i.REMARK);
          SET_STATUS_REASON(i.REASON);
        }
      });
  };
  const fetchCS_BySales = async (sales_id, crm_id) => {
    fetch(
      api_path + "/GET_CS_BYSALEID.php?saleid=" + sales_id + "&csid=" + crm_id,
    )
      .then((res) => res.json())
      .then((result) => {
        if (result["status"] == "200") {
          setShowCs(true);
        } else {
          setShowCs(false);
        }
      });
  };
  const onReceiveBooking = () => {
    swal({
      title: "Are you sure to receive this order?",
      text: "",
      icon: "info",
      dangerMode: false,
      buttons: true,
    }).then((isConfirm) => {
      if (isConfirm) {
        setReceiveButtonDisabled(false);
        updateOrderStatus(order_id, 2, "", getCrmId);
      }
    });
  };
  const onSendBooking = React.useCallback((e) => {
    swal({
      title: "Are you sure to send this order?",
      text: "",
      icon: "info",
      dangerMode: false,
      buttons: true,
    }).then((isConfirm) => {
      if (isConfirm) {
        setConfirmButtonDisabled(false);
        setLoading(true);
        updateOrderStatus(order_id, 1, "", getCrmId);
      }
    });
  }, []);
  function updateOrderStatus(ORDER_ID, ORDER_STATUS, REMARK, USER_ID) {
    var data = {
      ORDER_ID: ORDER_ID,
      ORDER_STATUS: ORDER_STATUS,
      REMARK: REMARK,
      REASON_ID: "",
      REASON_NAME: "",
      USER_ID: USER_ID,
    };
    fetch(api_path + "/TS_SALES_ORDER_UPDATE_STATUS.php", {
      method: "POST",
      headers: {
        Accept: "application/form-data",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result["status"] == "200") {
          swal("Done.", "Save data successfully.", "success", {
            buttons: true,
            timer: 5000,
          }).then(function () {
            const url =
              api_path +
              "/SENDMAIL_SALESORDER.php?order_id=" +
              ORDER_ID +
              "&order_status=" +
              ORDER_STATUS;
            axios
              .get(url)
              .then((response) => {
                // handle success
                console.log(result["message"]);
              })
              .then((data) => {
                console.log(data);
                // Handle data
              })
              .catch((error) => {
                // handle errors
              });
            window.location = "./SalesOrderDetail?order_id=" + ORDER_ID + "";
            ////////////////////////////////////////////////////
          });
        } else {
          swal("Sorry", result["message"], "error", {
            buttons: true,
            timer: 1000,
          });
        }
      });
  }

  const handleKeyDown = (event, callback) => {
    if (event.key === "Enter" && event.shiftKey === false) {
      event.preventDefault();
    }
  };
  const splitedStr = getAttachment.split(",");
  var returnStr = "";
  for (var i = 0; i < splitedStr.length; i++) {
    returnStr +=
      '<p><a href="https://apps.sinologistics.co.th/api/uploads/sales_order_local/' +
      splitedStr[i] +
      '" target="_blank">' +
      splitedStr[i] +
      "</a></p>";
  }
  const onEditBooking = (event) => {
    window.open(
      "/s-crm/SalesOrderForm?order_id=" +
        order_id +
        "&loadtype=" +
        GET_LOAD_TYPE,
      "_parent",
    );
  };
  return (
    <Container maxWidth="md" className="BorderBox">
      <BseData TYPE={type} SALES_CODE={getEmpCode} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          &nbsp;
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <label className="head">{subjectName}</label>
      </Grid>

      <Grid mb={2} container spacing={2}>
        <Grid item xs={12} sm={3}>
          <label>Request by</label>
          <p>{GET_CREATEBY}</p>
        </Grid>
        <Grid item xs={12} sm={3}>
          <label>Request Date</label>
          <p>{GET_ORDER_DATE}</p>
        </Grid>
        <Grid item xs={12} sm={3}>
          <label>ORDER NO</label>
          <p>{GET_ORDER_NO}</p>
        </Grid>

        <Grid item xs={12} sm={3}>
          <label>ORDER STATUS</label>
          <p className={`status${GET_ORDER_STATUS_ID}`}>
            {GET_ORDER_STATUS_NAME}
          </p>
        </Grid>
        {GET_STATUS_REASON && (
          <Grid item xs={12} sm={12} className="box">
            <label>{GET_ORDER_STATUS_NAME} REASON</label>
            <p>{GET_STATUS_REASON}</p>
            <label>REMARK</label>
            <p>{GET_STATUS_REMARK}</p>
          </Grid>
        )}
        <Grid item xs={12} sm={6}>
          <label>QUOTATION NO:</label>
          <p>{GET_QUOTATION_NO}</p>
        </Grid>
        <Grid item xs={12} sm={6}>
          <label>CUSTOMER REF:</label>
          <p>{GET_CUSTOMER_REF}</p>
        </Grid>

        <Grid item xs={12} sm={6}>
          <label>SALES</label>
          <p> {getSale}</p>
        </Grid>
        <Grid item xs={12} sm={6}>
          <label>CS</label>
          <p> {getCS}</p>
        </Grid>
        <Grid item xs={12} sm={6}>
          <label>CUSTOMER</label>
          <p>{GET_SHIPPER}</p>
        </Grid>
        <Grid item xs={12} sm={6}>
          <label>CONSIGNEE</label>
          <p> {GET_CONSIGNEE}</p>
        </Grid>
        <Grid item xs={12} sm={6}>
          <label>AGENT</label>
          <p>{GET_AGENT}</p>
        </Grid>

        <Grid item xs={12} sm={6}>
          <label>ACTUAL SHIPPER</label>
          <p> {GET_SHIPPERLOAD}</p>
        </Grid>
        <Grid item xs={12} sm={6}>
          <label>CO LOAD</label>
          <p> {GET_COLOAD}</p>
        </Grid>
        <Grid item xs={12} sm={6}>
          <label>3rd party shipment</label>
          <p>{GET_PARTY_3RD_NAME}</p>
        </Grid>

        <Grid item xs={12} sm={6}>
          <label>CREDIT TERM</label>
          <p> {GET_CREDIT_TERM}</p>
        </Grid>
        <Grid item xs={12} sm={6}>
          &nbsp;
        </Grid>

        <Grid item xs={12}>
          <hr className="underline" />
        </Grid>

        <Grid item xs={12} sm={3}>
          <label>BOUND TYPE:</label>
          <p>{GET_BOUND_TYPE}</p>
        </Grid>
        <Grid item xs={12} sm={3}>
          <label>SOLD BY:</label>
          <p> {GET_JOB_OWNER}</p>
        </Grid>
        <Grid item xs={12} sm={3}>
          <label>BOOKING BY:</label>
          <p> {GET_BOOKING_BY}</p>
        </Grid>
        <Grid item xs={12} sm={3}></Grid>

        <Grid item xs={12} sm={3}>
          <label>CUSTOMER CODE:</label>
          <p>{GET_CUSTOMER_CODE}</p>
        </Grid>
        <Grid item xs={12} sm={3}>
          <label>Paperless code with customs broker:</label>
          <p> {GET_PAPERLESS_CODE}</p>
        </Grid>
        <Grid item xs={12} sm={3}>
          <label>invoice local charge to:</label>
          <p> {GET_INVOICE_CHARGE_TO}</p>
        </Grid>
        <Grid item xs={12} sm={3}></Grid>

        <Grid item xs={12} sm={3}>
          <label>CARGO READY</label>
          <p>{GET_CARGO_READY}</p>
        </Grid>
        <Grid item xs={12} sm={3}>
          <label>CY DATE</label>
          <p>{GET_CY_DATE}</p>
        </Grid>
        <Grid item xs={12} sm={3}>
          <label>RETURN DATE</label>
          <p>{GET_RETURN_DATE}</p>
        </Grid>
        <Grid item xs={12} sm={3}>
          <label>ETD:</label>
          <p>{GET_ETD_DATE}</p>
        </Grid>
        <Grid item xs={12} sm={3}>
          <label>ETA:</label>
          <p>{GET_ETA_DATE}</p>
        </Grid>
        <Grid item xs={12} sm={9}></Grid>
        <Grid item xs={12}>
          <hr className="underline" />
        </Grid>
        <Grid item xs={12}>
          <label className="head3">PORT DETAILS</label>
        </Grid>
        <Grid item xs={12} sm={3}>
          <label>POR</label>
          <p>{GET_POR}</p>
          <p>{GET_POR_NAME}</p>
        </Grid>
        <Grid item xs={12} sm={3}>
          <label>POL</label>
          <p>{GET_POL}</p>
          <p>{GET_POL_NAME}</p>
        </Grid>
        <Grid item xs={12} sm={3}>
          <label>POD</label>
          <p>{GET_POD}</p>
          <p>{GET_POD_NAME}</p>
        </Grid>
        <Grid item xs={12} sm={3}>
          <label>DEL</label>
          <p>{GET_DEL}</p>
          <p>{GET_DEL_NAME}</p>
        </Grid>
        <Grid item xs={12} sm={3}>
          <label>FINAL</label>
          <p>{GET_FINAL}</p>
          <p>{GET_FINAL_NAME}</p>
        </Grid>
        <Grid item xs={12} sm={3}>
          <label>INLAND POSTCODE</label>
          <p>{GET_FINAL_ADDRESS}</p>
        </Grid>
        <Grid item xs={12} sm={6}>
          {" "}
        </Grid>
        <Grid item xs={12} sm={6}>
          <label>CARGO TYPE</label>
          <p>{GET_CARGO_TYPE}</p>
        </Grid>
        <Grid item xs={12} sm={3}>
          <label>COMMODITY</label>
          <p> {GET_COMMODITY}</p>
        </Grid>

        <Grid item xs={12} sm={3}>
          <label>HS Code</label>
          <p> {GET_HSCODE}</p>
        </Grid>
        <Grid item xs={12} sm={12}>
          <label className="head3">ATTACHMENT FILE:</label>
          {getAttachment != "" ? (
            <p>{ReactHtmlParser(returnStr)}</p>
          ) : (
            <p>No file.</p>
          )}
        </Grid>
        <Grid item xs={12}>
          <hr className="underline" />
        </Grid>
        <Grid item xs={12}>
          <label className="head3">CARRIER</label>
        </Grid>

        <Grid item xs={12} sm={6}>
          <label>Priority</label>
          <p> {GET_PRIORITY}</p>
        </Grid>
        <Grid item xs={12} sm={6}>
          <label>Waiting Sales to confirm release booking</label>
          <p> {GET_WAITING_FLAG}</p>
        </Grid>

        <Grid item xs={12} sm={12}>
          {CarrierData.map((item, index) => (
            <Grid
              container
              spacing={2}
              padding={2}
              key={index}
              className="box2"
            >
              <Grid item xs={12} sm={3}>
                <label>CARRIER</label>
                <p>
                  <span className="hilight">{item.CARRIER_CODE}</span>
                </p>
              </Grid>

              {showFCL && (
                <Grid item xs={12} sm={3}>
                  <label>SERVICE CONTRACT</label>
                  <p>
                    <span className="hilight">{item.SERVICES_CONTRACT}</span>
                  </p>
                </Grid>
              )}
              {showFCL && (
                <Grid item xs={12} sm={3}>
                  <label>BULLET</label>
                  <p>{item.BULLET_CODE}</p>
                </Grid>
              )}
              {showFCL && (
                <Grid item xs={12} sm={3}>
                  <label>REMARK</label>
                  {item.SPECIAL_FLAG !== "" &&
                    item.SPECIAL_FLAG !== null &&
                    item.SPECIAL_FLAG == 2 && (
                      <p className="red">{item.SCAC}</p>
                    )}
                  {item.SPECIAL_FLAG !== "" &&
                    item.SPECIAL_FLAG !== null &&
                    item.SPECIAL_FLAG != 2 && <p>{item.SCAC}</p>}
                </Grid>
              )}
              {showFCL && (
                <Grid item xs={12} sm={3}>
                  <label>DESCRIPTION</label>
                  <p>
                    <span className="hilight">{item.SC_CONDITION}</span>
                  </p>
                </Grid>
              )}
              {showFCL && (
                <Grid item xs={12} sm={3}>
                  <label>VALIDITY</label>
                  <p>
                    <span className="hilight">{item.SC_VALIDITY}</span>
                  </p>
                </Grid>
              )}

              <Grid item xs={12} sm={6}></Grid>
              {showLCL && (
                <Grid item xs={12} sm={3}>
                  <label>FREIGHT FORWARDER</label>
                  <p>{item.SERVICES_CONTRACT}</p>
                </Grid>
              )}
              <Grid item xs={12} sm={3}>
                <label>BOOKING REF</label>
                <p>{item.BOOKING_REF}</p>
              </Grid>
              <Grid item xs={12} sm={3}>
                <label>BOOKING NO</label>
                <p>{item.BOOKING_NO}</p>
              </Grid>
              <Grid item xs={12} sm={3}>
                <label>BSE NO</label>
                <p>{item.SMF_REFNO}</p>
              </Grid>
              <Grid item xs={12} sm={3}>
                <label>PROFORMA ETD</label>
                <p>{item.PROFORMA_ETD}</p>
              </Grid>
              <Grid item xs={12} sm={3}>
                <label>CTNR CUTOFF</label>
                <p>
                  {item.CONTAINER_CUTOFF_DATE} {item.CONTAINER_CUTOFF_TIME}
                </p>
              </Grid>
              <Grid item xs={12} sm={3}>
                <label>ETA</label>
                <p>{item.ETA}</p>
              </Grid>
              <Grid item xs={12} sm={6}></Grid>
              <Grid item xs={12} sm={3}>
                <label>ITEM STATUS</label>
                {item.STATUS_NAME == "ACTIVE" ||
                item.STATUS_NAME == "Confirm release" ? (
                  <p className="greenfont">{item.STATUS_NAME}</p>
                ) : (
                  <p className="redfont">{item.STATUS_NAME}</p>
                )}
              </Grid>
              <Grid item xs={12} sm={6}>
                <label>REMARK</label>
                <p>{item.REMARK}</p>
              </Grid>
            </Grid>
          ))}
        </Grid>
        <Grid item xs={12}></Grid>
        <Grid item xs={9}>
          <label className="head3">VOLUME</label>
        </Grid>
        <Grid item xs={3}></Grid>
        {showFCL && (
          <table border="1" width="80%">
            <tr className="box">
              <td width="80" colSpan="3" align="center">
                20'
              </td>

              <td width="80" colSpan="3" align="center">
                40'
              </td>

              <td width="80" colSpan="3" align="center">
                40HC
              </td>

              <td width="80" colSpan="3" align="center">
                45'
              </td>

              <td width="80" align="center">
                GW Remark
              </td>
            </tr>
            <tr>
              <td width="40" align="center">
                {" "}
                {GET_CNT20 == "0" ? "-" : GET_CNT20}
              </td>
              <td width="40" align="center">
                {GET_TYPE20}
              </td>
              <td width="40" align="center">
                {GET_GW20 === 0 ? "-" : GET_GW20.toLocaleString()}
              </td>
              <td width="40" align="center">
                {GET_CNT40 == "0" ? "-" : GET_CNT40}
              </td>
              <td width="40" align="center">
                {GET_TYPE40}
              </td>
              <td width="40" align="center">
                {GET_GW40 === 0 ? "-" : GET_GW40.toLocaleString()}
              </td>
              <td width="40" align="center">
                {" "}
                {GET_CNT40HQ == "0" ? "-" : GET_CNT40HQ}
              </td>
              <td width="40" align="center">
                {GET_TYPE40HQ}
              </td>
              <td width="40" align="center">
                {GET_GW40HQ === 0 ? "-" : GET_GW40HQ.toLocaleString()}
              </td>
              <td width="40" align="center">
                {GET_CNT45 == "0" ? "-" : GET_CNT45}
              </td>
              <td width="40" align="center">
                {GET_TYPE45}
              </td>
              <td width="40" align="center">
                {GET_GW45 === 0 ? "-" : GET_GW45.toLocaleString()}
              </td>
              <td align="center">{GET_GW}</td>
            </tr>
          </table>
        )}

        {showLCL && (
          <Grid item xs={12} sm={3}>
            <label>NUMBER OF PACKAGES</label>
            <p>{GET_NO_OF_PACK}</p>
          </Grid>
        )}
        {showLCL && (
          <Grid item xs={12} sm={3}>
            <label>PACKAGE UNIT</label>
            <p>{GET_PACKAGE_UNIT}</p>
          </Grid>
        )}
        {showLCL && (
          <Grid item xs={12} sm={3}>
            <label>CBM</label>
            <p>{GET_CBM}</p>
          </Grid>
        )}
        {showLCL && (
          <Grid item xs={12} sm={3}>
            <label>GW</label>
            <p>{GET_GW}</p>
          </Grid>
        )}
        {showLCL && (
          <Grid item xs={12} sm={12}>
            <label>DIMENSION_NOTE</label>
            <div className="box">{GET_DIMENSION_NOTE}</div>
          </Grid>
        )}
        {/* {containerData.map((item, index) => (
            <Grid container spacing={2} key={index}>
              {showFCL && (
                <Grid item xs={12} sm={3}>
                  <label>SIZE</label>
                  <p>{item.CTNR_SIZE}</p>
                </Grid>
              )}
              {showFCL && (
                <Grid item xs={12} sm={3}>
                  <label>TYPE</label>
                  <p>{item.CTNR_TYPE}</p>
                </Grid>
              )}
              {showFCL && (
                <Grid item xs={12} sm={3}>
                  <label>CONTAINER VOL.</label>
                  <p>{item.CTNR_QTY}</p>
                </Grid>
              )}
              {showFCL && (
                <Grid item xs={12} sm={3}>
                  <label>GW</label>
                  <p>{item.GW}</p>
                </Grid>
              )}

              {showLCL && (
                <Grid item xs={12} sm={2}>
                  <label>VOLUME</label>
                  <p>{item.CTNR_QTY}</p>
                </Grid>
              )}
              {showLCL && (
                <Grid item xs={12} sm={2}>
                  <label>UNIT</label>
                  <p>{item.CTNR_UNIT}</p>
                </Grid>
              )}
              {showLCL && (
                <Grid item xs={12} sm={2}>
                  <label>CBM</label>
                  <p>{item.CTNR_CBM}</p>
                </Grid>
              )}
              {showLCL && (
                <Grid item xs={12} sm={2}>
                  <label>GW</label>
                  <p>{item.GW}</p>
                </Grid>
              )}
              {showLCL && (
                <Grid item xs={12} sm={6}>
                  {" "}
                </Grid>
              )}
              {showLCL && (
                <Grid item xs={12} sm={8}>
                  <label>REMARK</label>
                  <p>{ReactHtmlParser(item.CTNR_REMARK)}</p>
                </Grid>
              )}
              {showLCL && <Grid item xs={12} sm={4}></Grid>}
            </Grid>
          ))} */}

        <Grid item xs={12}>
          <hr className="underline" />
        </Grid>
        <Grid item xs={12}>
          <label className="head3">SHIPMENT DETAILS</label>
        </Grid>
        <Grid item xs={12} sm={3}>
          <label>LOAD TYPE</label>
          <p> {GET_LOAD_TYPE}</p>
        </Grid>

        <Grid item xs={12} sm={3}>
          <label>INCOTERM</label>
          <p> {GET_INCOTERM}</p>
        </Grid>

        <Grid item xs={12} sm={3}>
          <label>CY TERM</label>
          <p> {GET_CY_TERM}</p>
        </Grid>
        <Grid item xs={12} sm={3}>
          <label>DOOR BY</label>
          <p> {GET_DOOR_BY}</p>
        </Grid>
        <Grid item xs={12} sm={3}>
          <label>MASTER BL TERM</label>
          <p> {GET_MBL_TERM}</p>
        </Grid>
        <Grid item xs={12} sm={3}>
          <label>MASTER BL TYPE</label>
          <p> {GET_MBL_TYPE}</p>
        </Grid>

        <Grid item xs={12} sm={3}>
          <label>HOUSE BL TERM</label>
          <p> {GET_HBL_TERM}</p>
        </Grid>
        <Grid item xs={12} sm={3}>
          <label>HOUSE BL TYPE</label>
          <p> {GET_HBL_TYPE}</p>
        </Grid>

        <Grid item xs={12} sm={3}>
          <label>SHIPPING</label>
          <p> {GET_SHIPPING}</p>
        </Grid>
        <Grid item xs={12} sm={3}>
          <label>TRUCKING</label>
          <p> {GET_TRUCKING}</p>
        </Grid>
        <Grid item xs={12} sm={3}>
          <label>REMARK</label>
          <p> {GET_TRUCKING_REMARK}</p>
        </Grid>
        <Grid item xs={12} sm={3}>
          <label>INSURANCE</label>
          <p> {GET_INSURANCE}</p>
        </Grid>

        <Grid item xs={12} sm={3}>
          <label>AMS/ACI Filing by</label>
          <p> {GET_AMS_SCAC}</p>
        </Grid>
        <Grid item xs={12} sm={3}>
          <label>ISF Filing by</label>
          <p>{GET_ISF_BY}</p>
        </Grid>
        {/* <Grid item xs={12} sm={3}>
          <label>FILING BY</label>
          <p> {GET_FILING_BY}</p>
        </Grid> */}
        <Grid item xs={12} sm={6}>
          &nbsp;
        </Grid>
        <Grid item xs={12}>
          <hr className="underline" />
        </Grid>
        <Grid item xs={12}>
          <label className="head3">PARTIES & CONTACT</label>
        </Grid>

        <Grid item xs={12} sm={12}>
          <label>REMARK TO CS</label>
          <p className="redfont">{GET_REMARK_TO_CS}</p>
        </Grid>
        <Grid item xs={12} sm={6}>
          <label>REMARK TO DOC</label>
          <p> {GET_REMARK_TO_DOC}</p>
        </Grid>
        <Grid item xs={12} sm={6}>
          <label>REMARK TO ACC</label>
          <p>{GET_REMARK_TO_ACC}</p>
        </Grid>

        <Grid item xs={12} sm={6}>
          <label>AGENT SALES EMAIL</label>
          <p>{GET_AGENT_SALES_EMAIL}</p>
        </Grid>
        <Grid item xs={12} sm={6}>
          <label>PREALERT EMAIL</label>
          <p>{GET_PREALERT_EMAIL}</p>
        </Grid>
        <Grid item xs={12} sm={6}>
          <label>BOOKING PIC</label>
          <p>{GET_BOOKING_PIC}</p>
        </Grid>
        <Grid item xs={12} sm={6}>
          <label>DOC PIC</label>
          <p>{GET_DOC_PIC}</p>
        </Grid>

        <Grid item xs={12}>
          <hr className="underline" />
        </Grid>
        {showSale && (
          <Grid item xs={12} sm={4}>
            <AddCancelModal
              ORDER_ID={order_id}
              USER_ID={getCrmId}
              ORDER_STATUS={GET_ORDER_STATUS_ID}
            />
          </Grid>
        )}
        {showCs && (
          <Grid item xs={12} sm={4}>
            <AddCancelModal
              ORDER_ID={order_id}
              USER_ID={getCrmId}
              ORDER_STATUS={GET_ORDER_STATUS_ID}
            />
          </Grid>
        )}
        {showSale && (
          <Grid item xs={12} sm={4}>
            <Button
              className="addBtn"
              //isLoading={isSubmitting}
              disabled={!isConfirmButtonDisabled}
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              onClick={onSendBooking}
            >
              Send Order
            </Button>
          </Grid>
        )}

        {showSale && (
          <Grid item xs={12} sm={4}>
            <Button
              type="button"
              fullWidth
              variant="contained"
              color="primary"
              onClick={onEditBooking}
              disabled={!isEditButtonDisabled}
            >
              Edit
            </Button>
          </Grid>
        )}
        {showCs && (
          <Grid item xs={12} sm={4}>
            <AddRejectModal
              ORDER_ID={order_id}
              USER_ID={getCrmId}
              ORDER_STATUS={GET_ORDER_STATUS_ID}
            />
          </Grid>
        )}
        {showCs && (
          <Grid item xs={12} sm={4}>
            <AddReceiveModal
              ORDER_ID={order_id}
              USER_ID={getCrmId}
              USER_EMAIL={getUserEmail}
              ORDER_STATUS={GET_ORDER_STATUS_ID}
            />
            {/* <Button
              disabled={!isReceiveButtonDisabled}
              type="button"
              fullWidth
              variant="contained"
              color="primary"
              onClick={onReceiveBooking}
            >
              RECEIVE
            </Button> */}
          </Grid>
        )}
      </Grid>
    </Container>
  );
}
